export { DSButtonV2, DSButtonV2WithSchema } from './DSButtonV2.js';
export type { DSButtonV2T } from './react-desc-prop-types.js';
